import { render, staticRenderFns } from "./PublishEvent.vue?vue&type=template&id=b556c36c&scoped=true&"
import script from "./PublishEvent.vue?vue&type=script&lang=js&"
export * from "./PublishEvent.vue?vue&type=script&lang=js&"
import style0 from "./PublishEvent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PublishEvent.vue?vue&type=style&index=1&id=b556c36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b556c36c",
  null
  
)

export default component.exports